import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <TopicsSection />
        <FAQSection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <FeaturesSection />
        <CarouselSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}